import React from "react";
import { Helmet } from "react-helmet";
import "../css/privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Garud Cab Service</title>

        <meta
          name="description"
          content="Privacy Policy for Garud Cab Service. Learn how we collect, use, and protect your personal information while using our cab booking, airport transfer, local, rental, and outstation travel services."
        />

        <meta
          name="keywords"
          content="Garud Cab Service, Cab Service, Taxi Booking, Airport Transfer, Outstation Travel, Car Rental, Privacy Policy"
        />
      </Helmet>
<section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Privacy Policy
        </h2>
      </div>
    </section>
      {/* Banner */}
   
      {/* Privacy Policy Section */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <img
              src="/images/privacy.jpg"
              alt="Garud Cab Service Privacy Policy"
            />

            <div className="col-12 col-md-12">
              <h3 className="title">
                Privacy Policy – Garud Cab Service
              </h3>

              <p>
                At <b>Garud Cab Service</b>, we respect your privacy and are
                committed to protecting your personal information. This Privacy
                Policy explains how we collect, use, store, and protect your
                information when you use our cab booking and transportation
                services.
              </p>

              {/* Information We Collect */}
              <div className="section">
                <p className="highlight darkcolor">
                  Information We Collect:
                </p>

                <p className="highlight darkcolor">
                  1. Personal Information:
                </p>

                <p>
                  We may collect information such as your name, mobile number,
                  email address, pickup and drop locations, travel date,
                  passenger details, and payment-related information required
                  to provide our services.
                </p>

                <p className="highlight darkcolor">
                  2. Booking Information:
                </p>

                <p>
                  We collect ride-related information including booking time,
                  pickup location, destination, travel details, vehicle
                  preference, number of passengers, and other information
                  necessary to complete your booking.
                </p>

                <p className="highlight darkcolor">
                  3. Device & Usage Information:
                </p>

                <p>
                  We may collect technical information such as device type,
                  browser information, IP address, operating system, and
                  website usage information to improve website performance and
                  customer experience.
                </p>
              </div>

              {/* How We Use Information */}
              <div className="section">
                <p className="highlight darkcolor">
                  How We Use Your Information:
                </p>

                <p className="highlight darkcolor">
                  1. Booking & Service Management:
                </p>

                <p>
                  Your information is used to confirm bookings, assign
                  appropriate vehicles, coordinate with drivers, process
                  requests, and provide transportation services.
                </p>

                <p className="highlight darkcolor">
                  2. Customer Support:
                </p>

                <p>
                  We use your information to provide booking confirmations,
                  trip updates, invoices, payment confirmations, customer
                  support, and other service-related communications.
                </p>

                <p className="highlight darkcolor">
                  3. Service Improvement:
                </p>

                <p>
                  We may analyze customer feedback and service usage to improve
                  our cab services, vehicle availability, safety standards, and
                  overall customer experience.
                </p>

                <p className="highlight darkcolor">
                  4. Promotions & Updates:
                </p>

                <p>
                  With your permission, we may send information about special
                  offers, discounts, travel services, and promotional
                  communications. You may opt out of promotional communications
                  at any time.
                </p>
              </div>

              {/* Information Sharing */}
              <div className="section">
                <p className="highlight darkcolor">
                  Information Sharing:
                </p>

                <p className="highlight darkcolor">
                  1. Drivers:
                </p>

                <p>
                  Necessary booking information may be shared with the assigned
                  driver so that the driver can locate the pickup point,
                  contact the passenger when required, and complete the
                  journey.
                </p>

                <p className="highlight darkcolor">
                  2. Payment & Service Partners:
                </p>

                <p>
                  Limited information may be shared with trusted payment
                  providers, technology providers, or service partners when
                  necessary to process payments and operate our services.
                </p>

                <p className="highlight darkcolor">
                  3. Legal Requirements:
                </p>

                <p>
                  We may disclose personal information when required by
                  applicable law, government authorities, court orders, or
                  other valid legal processes.
                </p>
              </div>

              {/* Security & Data */}
              <div className="section">
                <p className="highlight darkcolor">
                  Data Security:
                </p>

                <p>
                  Garud Cab Service takes reasonable measures to protect your
                  personal information against unauthorized access, misuse,
                  alteration, disclosure, or loss.
                </p>

                <p className="highlight darkcolor">
                  Data Retention:
                </p>

                <p>
                  We retain personal and booking information only for as long
                  as reasonably necessary to provide our services, maintain
                  business records, resolve disputes, and comply with applicable
                  legal requirements.
                </p>

                <p className="highlight darkcolor">
                  Your Rights:
                </p>

                <p>
                  Subject to applicable laws, you may request access to,
                  correction of, or deletion of your personal information.
                  Requests may be submitted using the contact information
                  provided below.
                </p>

                <p className="highlight darkcolor">
                  Cookies:
                </p>

                <p>
                  Our website may use cookies and similar technologies to
                  improve website functionality, remember preferences, analyze
                  website traffic, and enhance the overall user experience.
                </p>

                <p className="highlight darkcolor">
                  Third-Party Links:
                </p>

                <p>
                  Our website may contain links to third-party websites or
                  services. Garud Cab Service is not responsible for the
                  privacy practices, content, or policies of external websites.
                  Customers are encouraged to review their respective privacy
                  policies.
                </p>

                <p className="highlight darkcolor">
                  Children's Privacy:
                </p>

                <p>
                  Our services are intended for general customers and are not
                  specifically directed toward children. We do not knowingly
                  collect personal information from children without appropriate
                  consent where required by applicable law.
                </p>

                <p className="highlight darkcolor">
                  Policy Updates:
                </p>

                <p>
                  Garud Cab Service may update this Privacy Policy from time to
                  time to reflect changes in our services, technology, or legal
                  requirements. Any updated version will be published on this
                  page.
                </p>
              </div>

              {/* Consent */}
              <div className="section">
                <p className="highlight darkcolor">
                  Consent:
                </p>

                <p>
                  By using the Garud Cab Service website or booking our
                  transportation services, you acknowledge that you have read
                  and understood this Privacy Policy and agree to the collection
                  and use of information as described in this policy, subject
                  to applicable law.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Garud Cab Service</h2>

            <p>
              For privacy-related questions, requests, or concerns, please
              contact Garud Cab Service:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919970007784">
                  +91 9970007784
                </a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@garudcabs.com">
                  booking@garudcabs.com
                </a>
              </li>

              <li>
                <b>Address:</b>
                <br />

                <h6>Garud Cab Service</h6>

               
                 Office No.101 Anand Heights<br/>
                 Chandan Nagar, Kharadi, Pune,<br/>
                 Maharashtra, India-  411014
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;